<div class="ui-dashboard" id="dashFwa">

  <div class="dashboard-wrapper m-b-30">

    <div class="p-b-10">
      <div class="grid grid-gap-20 grid-2x grid-2x-responsive p-b-20">

        <!-- LHS -->
        <div>
          <h2 class="dashboard-head">FWA Dashboard</h2>
        </div>

        <!-- RHS -->
        <div class="text-a-right">
          <nz-range-picker [(ngModel)]="dashboardDateRange" (ngModelChange)="onDashboardDateRangeSelection($event)"
            class="dash-date-range" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
          </nz-range-picker>
        </div>

      </div>
    </div>


    <!-- TOP WIDGETS -->
    <div *ngIf="widgetReady" class="stat-widgets p-t-0 grid grid-5x grid-gap-10 grid-5x-responsive">
      <div *ngFor="let item of dataCARDS; let i=index;" class="stat-widget"
        [ngStyle]="{ 'backgroundColor': colorScheme.domain[i] }">
        <div class="stat-widget-body">
          <strong>{{item.value}}</strong>
          {{item.name}}
        </div>
        <div *ngIf="item.breakup" class="stat-widget-footer">
          <table class="w-100-pc">
            <tr *ngFor="let subItem of item.breakup">
              <td>{{subItem.key}}</td>
              <td class="text-a-right">{{subItem.value}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- Separator -->
    <div class="p-t-10"></div>

    <div style="padding: 30px 0 50px 0;border-radius: 7px; background-color: #393862; color: #001529"
      [hidden]="!widgetReady">
      <div class="funnel-container" [style.min-height.px]="graphHeight-10"
        style="width: 100%;background-color: transparent;padding:0">
        <!-- funnel-chart will be injected here -->
      </div>
    </div>

    <!-- Separator -->
    <div class="p-t-20"></div>

    <div class="viewReportAndCheckFraudSection flexie-auto-grid">
      <div class="monthly-weekly-graph-area p-10">
        <div class="flexie-auto-grid">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b">Potential Fraud Policies</h3>
          </div>
          <div class="text-a-right">
            <nz-radio-group [(ngModel)]="monthlyOrWeekly" [nzButtonStyle]="'solid'">
              <label nz-radio-button nzValue="monthly">Monthly</label>
              <label nz-radio-button nzValue="daily">Daily</label>
            </nz-radio-group>
          </div>
        </div>
        <div class="flex flex-horiz-center">
          <!-- <ngx-charts-bar-vertical [view]="[1000,400]" [results]="monthlyWeeklyReport[monthlyOrWeekly]['report']"
              [xAxisLabel]="monthlyWeeklyReport[monthlyOrWeekly]['label']" [yAxisLabel]="'FWA'" [legend]="false"
              [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxis]="true" [yAxis]="true" [gradient]="false">
            </ngx-charts-bar-vertical> -->
          <ngx-charts-line-chart [view]="[1000,400]" [results]="monthlyWeeklyReport[monthlyOrWeekly]"
            [xAxisLabel]="monthlyWeeklyReport[monthlyOrWeekly][0]['name']" [yAxisLabel]="'FWA'" [legend]="false"
            [scheme]="colorScheme" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxis]="true" [yAxis]="true"
            [gradient]="false">
          </ngx-charts-line-chart>
        </div>
      </div>
    
      <div class="quick-check-fraud-area">
        <div class="flexie-auto-grid">
          <div style="font-size: 18px;">
            <i nz-icon nzType="alert" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b">Quick Check Fraud</h3>
          </div>
        </div>
        <div class="">
          <div>
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
              <input type="text" nz-input placeholder="Input Policy Number" [(ngModel)]="claimNumberSearch" />
            </nz-input-group>
            <ng-template #suffixIconButton>
              <button nz-button nzType="primary" nzSearch (click)="searchClaim()" [disabled]="!claimNumberSearch">
                <i nz-icon nzType="search"></i>
              </button>
            </ng-template>
          </div>
    
          <div *ngIf="!displayFraudDataCards">
            <div class="emptyBox">
              <i nz-icon nzType="fund" nzTheme="outline" style="font-size: 35px; padding: 10px;"></i>
              Fraud analysis will be displayed here.
              </div>
          </div>

          <div class="m-t-20" *ngIf="fraudPredicationMsg;else showFraudData">
            <nz-alert [nzType]="'error'" [nzMessage]="fraudPredicationMsg" class="m-b-20">
            </nz-alert>
          </div>

          <ng-template #showFraudData>
          <div class="pos-relative d-b w-100 m-t-20" *ngIf="displayFraudDataCards">
            <div class="fwa-summary-section grid grid-1x grid-1x-responsive grid-gap-20">
              <div class="fwa-summary-block fwa-summary-block-grid">
                <div>
                  <h5><em nz-icon nzType="security-scan"></em> {{'Fraud propensity' | MMSTranslate}}</h5>
                  <p class="col-grey-light">
                    {{' Fraud propensity score is the measure of the probability of fraud. The higher the score, the
                    higher the chance of fraud.' | MMSTranslate}}
                  </p>
                  <p class="col-grey-light">Fraud risk is <span class="f-w-700">{{getRiskValue(fraudIO['predictionProbabilityPercent'])}}</span></p>
                </div>
                <!-- getColor(fraudIO.rating) -->
                <div class="flex flex-both-center h-100-pc">
                  <nz-progress [nzPercent]="fraudIO['predictionProbabilityPercent']" nzType="dashboard" [nzWidth]="96"
                    [nzFormat]="getFraudPropensity" [nzStrokeColor]="fraudIO['color']">
                  </nz-progress>
                </div>
              </div>
              <div class="fwa-summary-block fwa-summary-block-grid">
                <div>
                  <h5><em nz-icon nzType="warning"></em> {{'Risk Score' | MMSTranslate}}</h5>
                  <div class="col-grey-light" style="font-size: 12px;">
                    {{'The risk score is calculated based on various factors like Timelag in intimation, Intimation location, Branch Location,
                    Product Name, Age of Life Assured, Occupation, Income, Type of U/W, risk Score at UW, Claim Liability and many more.' | MMSTranslate}}
                    <!-- !!!!!! IMPORTANT NOTE TO DEV.: MAKE HARD-CODED RANGE VALUES TO DYNAMIC VARS -->
                    <!-- <div>
                      <span> &#62;75 </span> {{'is high risk' | MMSTranslate}}
                    </div>
                    <div>
                      <span> 25-75 </span> {{'is medium risk and' | MMSTranslate}}
                    </div>
                    <div>
                      <span> &#60;25 </span> {{'is low risk' | MMSTranslate}}
                    </div> -->
                  </div>
                </div>
                <div class="flex flex-both-center h-100-pc">
                  <!-- !!!!! IMPORTANT NOTE TO DEV.: MAKE HARD-CODED RANGE BELOW (70) TO DYNAMIC VARS -->
                  <nz-progress [nzPercent]="fraudIO['predictionProbabilityPercent']" nzType="dashboard" [nzWidth]="96"
                    [nzFormat]="getRiskValue" [nzStrokeColor]="fraudIO['color']">
                  </nz-progress>
                </div>
              </div>
              <!-- <div class="fwa-summary-block">
                <h5><em nz-icon nzType="file-text"></em> {{'Fraud reasons' | MMSTranslate}}</h5>
                <ul class="ul-dot m-l-15">
                  <li *ngFor="let reason of fraudReasonsList"> {{reason}} </li>
                </ul>
              </div> -->
            </div>
          </div>
        </ng-template>
    
        </div>
      </div>
    
    </div>
    <!-- Separator -->
    <div class="p-t-20"></div>

    <div class="triggers-of-FWA-section">
      <div class="flexie-auto-grid">
        <div style="font-size: 18px;">
          <i nz-icon nzType="alert" nzTheme="outline" class="m-r-5"></i>
          <h3 class="d-i-b">Triggers of FWA</h3>
        </div>
      </div>
      <div class="grid grid-30-auto p-20 grid-gap-20">
        <div>
          <div class="flexie-auto-grid">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select" [(ngModel)]="selectedTrigger"
              style="width: 100%;">
              <nz-option nzLabel="Pincode" nzValue="Pincode"></nz-option>
              <!-- <nz-option nzLabel="Hospital" nzValue="Hospital"></nz-option> -->
              <nz-option nzLabel="TPA" nzValue="TPA"></nz-option>
            </nz-select>
            <button nz-button nzType="primary" (click)="fetchTriggers()" class="m-l-5" [disabled]="selectedTrigger">Search</button>
          </div>
          <div>
          </div>
        </div>

        <div>
          <!-- <div class="flexie-auto-grid">
          <h5 class="d-b p-t-b-10">
            <span>Triggers: Search Results</span>
          </h5>
          <div class="text-a-right">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton" style="width: 50%;">
              <input type="text" nz-input placeholder="Search ..." [(ngModel)]="claimNumberSearch" />
            </nz-input-group>
            <ng-template #suffixIconButton>
              <button nz-button nzType="primary" nzSearch (click)="searchTriggerRecord()"><i nz-icon nzType="search"></i></button>
            </ng-template>
          </div>
        </div> -->
          <div>
            <nz-table #basicTable [nzData]="dataSet" nzSize="small" [nzShowPagination]="false" class="d-b"
              [nzScroll]="{x: '480px'}">
              <thead>
                <tr>
                  <th scope="col">Trigger</th>
                  <th scope="col">Cluster</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let u of basicTable.data">
                  <td><span>{{u.message}}</span></td>
                  <td>{{u.cluster}}</td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>

        <!--Spacer-->
        <div class="p-t-10"></div>

      </div>
    </div>

    <!-- Separator -->
    <div class="p-t-20"></div>

    <div class="">
      <div class="flexie-auto-grid">
        <div style="font-size: 18px;">
          <i nz-icon nzType="dashboard" nzTheme="outline" class="m-r-5"></i>
          <h3 class="d-i-b">Machine Learning Model Performance</h3>
        </div>
      </div>
      <div class="viewReportAndCheckFraudSection flexie-auto-grid">
        <div class="flex flex-horiz-center">
          <ngx-charts-line-chart [view]="[1000,400]" [results]="MLPredictionVsActualResult"
            [xAxisLabel]="'Year(s)'" [yAxisLabel]="'FWA'" [legend]="true" [legendPosition]="'below'"
            [scheme]="colorScheme" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxis]="true" [yAxis]="true"
            [gradient]="false">
          </ngx-charts-line-chart>
        </div>
        
        <div>
          <div class="pos-relative d-b w-100">
            <div class="fwa-summary-section grid grid-1x grid-1x-responsive grid-gap-20">
              <div class="flexie-auto-grid">
                <div>
                  <button nz-button nzType="primary" (click)="showRetrainPopup()" [disabled]="trainingInProgress">Retrain Model</button>
                </div>

                <div class="text-a-right">
                  <nz-tag [nzColor]="currentRetrainStatus == 'Training in Progress' ? 'orange' : 'green'">{{currentRetrainStatus}}</nz-tag>
                  <button nz-button nzType="primary" nzShape="circle" nzTooltipTitle="Fetch current training status" nz-tooltip>
                    <em nz-icon nzType="redo" nzTheme="outline"></em>
                  </button>
                </div>
              </div>

              <div class="fwa-summary-block">
                <div>
                  <h5><em nz-icon nzType="security-scan"></em> {{'Recommendation' | MMSTranslate}}</h5>
                    <ul class="ul-dot m-l-15">
                      <li>Retraining is required.</li>
                      <li>Please ensure all cases which are not fraud are marked accordingly.</li>
                    </ul>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>


  </div>

</div>


<nz-modal [(nzVisible)]="isRetrainModelPopup" nzTitle="Retrain Model" (nzOnCancel)="cancelRetrainModelPopup()" 
  (nzOnOk)="callToRetrainModel()" nzOkText="Proceed">
  <ng-container *nzModalContent>
  <p class="text-a-center">Please enter the OTP sent to your registered email id xyz@abc.com</p>
  <div class="text-a-center">
    <nz-input-group [nzSuffix]="suffixTemplate" style="width: 200px;">
      <input [type]="passwordVisible ? 'text' : 'password'" nz-input placeholder="OTP" [(ngModel)]="enteredOTP" autocomplete="off" />
    </nz-input-group>
    <ng-template #suffixTemplate>
      <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="passwordVisible = !passwordVisible"></i>
    </ng-template>
  </div>
  </ng-container>
  
</nz-modal>